import { REDUX_ACTION } from '@/Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { ChangeFontFace } from '@/utils/FontHelper'
import i18n from '@/i18n'

export const InitLanguage = () => {
    if (i18n.language) {
        let language = i18n.language
        switch (i18n.language.toLowerCase()) {
            case 'ko':
            case 'ko-kr': language = 'ko'; break

            case 'ja':
            case 'jp':
            case 'ja-jp': language = 'jp'; break

            case 'en':
            case 'en-us':
            default: language = 'en'; break
        }

        SetLanguage(language)
    }
}

export const SetLanguage = language => {
    i18n.changeLanguage(language)
    ReduxBinding(REDUX_ACTION.LANG, language)

    ChangeFontFace(language)
}
